import { motion, useScroll, useTransform } from "framer-motion";

const SRC = { a: "/images/leaf-a.webp", b: "/images/leaf-b.webp" };

export function LeafCutout({ variant = "a", className = "", speed = 0.15, flip = false }: { variant?: "a" | "b"; className?: string; speed?: number; flip?: boolean }) {
  const { scrollY } = useScroll();
  const y = useTransform(scrollY, [0, 1500], [0, -1500 * speed]);
  return (
    <motion.div aria-hidden="true" style={{ y }} className={`pointer-events-none absolute select-none ${className}`}>
      <img src={SRC[variant]} alt="" loading="lazy" className={`h-full w-full animate-sway object-contain drop-shadow-[0_30px_40px_rgba(0,0,0,0.35)] ${flip ? "-scale-x-100" : ""}`} />
    </motion.div>
  );
}
